import { IconButton, Typography } from "@mui/material"
import BranchType from "../../interfaces/branch"
import EditIcon from '@mui/icons-material/Edit';

interface IProps {
    branch: BranchType
}

export default function Branch({branch}: IProps) {
  return (
    <div className='rounded-lg bg-primary-hover flex flex-row gap-4 items-center p-4'>
        <img className="rounded-full shadow-lg w-20 h-20" src='/company.png' />
        <div className='flex flex-col grow gap-2'>
            <Typography className="text-text-secondary text-base">{branch.name}</Typography>
            <Typography className="text-sm">{branch.address}</Typography>
        </div>
        <IconButton color="primary">
            <EditIcon />
        </IconButton>
    </div>
  )
}
